module.exports = __webpack_public_path__ + "static/img/record2.a6a02982.png";